import React from "react";
import { withTranslation } from "react-i18next";
import { Documents, InformationReliable, PersonalData } from "../../../assets/logos/icons";
import { LocalStorageService, ContractorService, ProcedureUserService } from "../../../services";
import { ProfileValidator } from '../../../validators'
import ContractingRegistrationDataView from "../../views/contracting-registration/contracting-registration-data.view";
import ContractingRegistrationDocumentsView from "../../views/contracting-registration/contracting-registration-documents.view";
import ContractingRegistrationResumeView from "../../views/contracting-registration/contracting-registration-resume.view";
import ContractingRegistrationView from "../../views/contracting-registration/contracting-registration.view";
import { RegistrationFreelanceDataView } from "../../views";
class ContractingRegistrationAction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      user: {},
      selectedStep: 0,
      token: "",
      shouldRefresh: false,
      message: "",
      messageError: "",
      showLoadingRequesting: false,
      showCompletedRequesting: false,
      showErrorRequesting: false,
      showWarningRequesting: false,
      documentsUpload: [],
      contractorPersonType: [],
      contractorClientDocuments: [],
      url: process.env.REACT_APP_MIFIRMA_API,
      idContractor: 0,
      selectedFile: null,
      errorFile: false,
      selectedFileBase64: "",
      colorBorderContainer: "gray",
      personTypes: [],
      freelanceData: {},
      isFreelanceView: false,
      documentsFree: [],
      documentPathSyncFusion: '',
      titleView: this.props.t("contractingRegistrationDataView.title.registryContractor")
    };
  }

  token = {};
  url = process.env.REACT_APP_MIFIRMA_API;
  localStorageService = new LocalStorageService();
  contractorService = new ContractorService(this.url)
  procedureUserService = new ProcedureUserService(this.url)
  validator = ProfileValidator(this.props.t);
  isFreelanceView = false
  freelanceId = 0
  workflowFreelanceId = ''

  async componentDidMount() {
    let user = this.localStorageService.getLocalStorageItem('user')
    this.token = this.localStorageService.getLocalStorageItem('token').idToken
    let urlArr = window.location.href.split('/')
    let route = urlArr[4]
    this.isFreelanceView = (route === 'registration-user-freelance') ? true : false
    let idContractor = 0
    let titleView = this.props.t("contractingRegistrationDataView.title.registryContractor")
    if (this.isFreelanceView) {
      titleView = this.props.t("contractingRegistrationDataView.title.userRegistrationProcedure")
      this.toggleLoadingRequesting(true)
      this.freelanceId = Number(urlArr[urlArr.length - 1])
    } else {
      idContractor = urlArr[urlArr.length - 1]
      this.getContractPersonTypes()
      this.getPersonType()
    }

    this.setState(
      {
        token: this.token,
        user: user,
        idContractor: Number(idContractor),
        loading: false,
        isFreelanceView: this.isFreelanceView,
        titleView
      }
    );
  }

  forceRefresh = () => {
    this.setState(({ shouldRefresh }) => ({ shouldRefresh: !shouldRefresh }));
  };

  //Function loading dialog
  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value,
    });
  };

  //Function completed dialog

  toggleCompletedRequesting = (value, time) => {
    this.setState(
      {
        showCompletedRequesting: value,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showCompletedRequesting: false,
          });
        }, time || 3000);
      }
    );
  };

  //Funtion error dialog
  toggleErrorRequesting = (value, time, message) => {
    this.setState(
      {
        showErrorRequesting: value,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showErrorRequesting: false,
          });
        }, time || 3000);
      }
    );

    if (message) {
      this.setState({
        messageError: message
      })
    }
  };

  //Funtion warning dialog
  toggleWarningRequesting = (value, message) => {
    this.setState(
      {
        showWarningRequesting: value,
        message: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showWarningRequesting: false,
            message: "",
          });
        }, 4000);
      }
    );
  };

  /**Start action buttons back and next stepper**/
  onBackStep = () => {
    if (this.state.selectedStep === 0) {
      window.history.back();
    } else {
      this.setState({
        selectedStep: this.state.selectedStep - 1
      })
    }
    return window.scroll(0, 0)
  }

  onNextStep = () => {
    this.setState({
      selectedStep: this.state.selectedStep + 1,
    })
    return window.scroll(0, 0)
  }


  //set documents was selected
  setDocumentsSeleceted = (documents) => {
    this.setState({
      documentsUpload: documents
    })
  }

  //get contract person type
  getContractPersonTypes = async () => {
    try {
      let contractorPersonType = await this.contractorService.getContractorsPerson(this.token)
      if (contractorPersonType && contractorPersonType.data && contractorPersonType.data.data && Number(contractorPersonType.status) === 200) {
        let typePersonFiler = (contractorPersonType.data.data && contractorPersonType.data.data.contractor) ? contractorPersonType.data.data.contractor.filter((type) => type.id !== 0) : []
        this.setState({
          contractorPersonType: typePersonFiler
        })
      }
    } catch (error) {
      console.log(error)
      this.toggleErrorRequesting(true, 400)
    }
  }

  setContractorClientDocuments(documents) {
    this.setState({
      contractorClientDocuments: documents
    })
  }


  steps = [
    {
      icon: InformationReliable,
      title: this.props.t("contractingRegistrationDataView.step1.button.stepTitle"),
      next: this.props.t("contractingRegistrationDataView.step1.button.stepButtonContinue"),
      back: this.props.t("contractingRegistrationDataView.step1.button.stepButtonBack"),
    },
    {
      icon: PersonalData,
      title: this.props.t("contractingRegistrationDataView.step2.button.stepTitle"),
      next: this.props.t("contractingRegistrationDataView.step2.button.stepButtonContinue"),
      back: this.props.t("contractingRegistrationDataView.step2.button.stepButtonBack"),
    },
    {
      icon: Documents,
      title: this.props.t("contractingRegistrationDataView.step3.button.stepTitle"),
      next: this.props.t("contractingRegistrationDataView.step3.button.stepButtonContinue"),
      back: this.props.t("contractingRegistrationDataView.step3.button.stepButtonBack"),
    }
  ]

  pdfToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  handleFile = async (e) => {
    this.setState({
      selectedFile: e.target.files[0],
      selectedFileName: e.target.files[0].name,
      errorFile: false,
      colorBorderContainer: "green",
    });

    // Upload the base64 in the state
    let fileBase64 = await this.pdfToBase64(e.target.files[0]);
    let pdfBase64 = fileBase64.split(",")[1];
    this.setState({ selectedFileBase64: pdfBase64 });
  };

  handleSetNameDocument = (documento) => {
    this.setState({
      selectedFile: documento,
      selectedFileName: documento.name,
      errorFile: false,
      colorBorderContainer: "green",
    });
  }

  handleDeleteFile = (e) => {
    this.setState({
      selectedFile: null,
      errorFile: false,
      deletePfd: true,
      selectedFileBase64: "",
      colorBorderContainer: "gray",
    });
    return true;
  };

  stepMetadata = [
    { number: 0, component: ContractingRegistrationDataView, back: this.onBackStep, next: this.onNextStep },
    { number: 1, component: ContractingRegistrationDocumentsView, back: this.onBackStep, next: this.onNextStep },
    { number: 2, component: ContractingRegistrationResumeView, back: this.onBackStep, next: this.onNextStep },
  ]


  getPersonType = async () => {
    try {
      let contractorPersonType = await this.contractorService.getPersonTypeByKey('documentType', this.token)
      if (contractorPersonType && contractorPersonType.data && Number(contractorPersonType.statusCode) === 200) {
        let personTypes = contractorPersonType.data
        personTypes.map((type) => {
          type.name = type.value
          return type
        })
        this.setState({
          personTypes,
        })
      } else {
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(true, 400)
      }
    } catch (error) {
      this.toggleLoadingRequesting(false)
      this.toggleErrorRequesting(true, 400)
    }
  }

  //Pantalla de Freelance
  stepMetadataFree = [
    { number: 0, component: RegistrationFreelanceDataView, back: this.onBackStep, next: this.onNextStep },
    { number: 1, component: ContractingRegistrationDocumentsView, back: this.onBackStep, next: this.onNextStep },
    { number: 2, component: ContractingRegistrationResumeView, back: this.onBackStep, next: this.onNextStep },
  ]

  getFreelanceData = async () => {
    this.toggleLoadingRequesting(true)
    let messageError = 'Ocurrió un error al consultar la información'
    try {
      let procedureUser = await this.procedureUserService.getProcedureUserData(this.freelanceId, this.token)
      if (procedureUser && procedureUser.data && Number(procedureUser.statusCode) === 200) {
        //Information procedure user
        let dateConvert = (procedureUser.data.procedureUser.birthdate) ? new Date(procedureUser.data.procedureUser.birthdate) : ''
        let freeData = {
          name: procedureUser.data.procedureUser.name,
          lastname: procedureUser.data.procedureUser.firstlastname,
          secondLastname: procedureUser.data.procedureUser.secondlastname,
          rfc: procedureUser.data.procedureUser.rfc,
          curp: procedureUser.data.procedureUser.curp,
          address: procedureUser.data.procedureUser.address,
          city: procedureUser.data.procedureUser.city,
          state: procedureUser.data.procedureUser.state,
          cp: procedureUser.data.procedureUser.zip,
          birthPlace: procedureUser.data.procedureUser.placeofbirth,
          nationality: procedureUser.data.procedureUser.nacionality,
          date: (dateConvert) ? dateConvert : '',
          passport: procedureUser.data.procedureUser.passportnumber,
          passportCountry: (procedureUser.data.procedureUser.countrypassport) ? procedureUser.data.procedureUser.countrypassport : 'México',
        }

        //Documents procedure user
        let documentsFree = []
        let documentPathSyncFusion = ''
        let documentsPromise = Promise.all(procedureUser.data.documents.map(async (documento) => {
          let document = {
            id: documento.id,
            clientDocumentId: documento.clientDocumentId,
            name: (documento.clientDocument.clientDocumentTypeRequestId === 2) ? `${documento.clientDocument.name}*` : documento.clientDocument.name,
            description: documento.clientDocument.description,
            userId: documento.userId,
            path: documento.pathDocument,
            dateToShow: (documento.documentWasLoaded) ? documento.updatedDateDoc : '',
            createdDate: documento.createdDateDoc,
            updatedDate: documento.updatedDateDoc,
            status: (documento.documentWasLoaded) ? this.props.t("contractingRegistrationDataView.grid.registeredThe") : this.props.t("contractingRegistrationDataView.grid.pending"),
            documentWasLoaded: documento.documentWasLoaded,
            clientDocumentTypeRequestId: documento.clientDocument.clientDocumentTypeRequestId,
            isForm: documento.isForm
          }
          if (documento.isForm) {
            documentPathSyncFusion = document.path
          }
          documentsFree.push(document)
          return document
        }))

        await documentsPromise

        //workflow procedure user
        this.workflowFreelanceId = procedureUser.data.workflowExecution.id

        this.setState({
          freelanceData: freeData,
          documentsFree,
          documentPathSyncFusion
        })
        this.toggleLoadingRequesting(false)
      } else if (Number(procedureUser.statusCode) === -5) {
        messageError = 'No se encontro al usuario trámite en govo.legal'
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(true, 4000, messageError)
      } else if (Number(procedureUser.statusCode) === -6) {
        messageError = 'No se encontro el workflow del usuario trámite en govo.legal'
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(true, 4000, messageError)
      } else {
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(true, 4000, messageError)
      }
    } catch (error) {
      this.toggleLoadingRequesting(false)
      this.toggleErrorRequesting(true, 4000, messageError)
    }
  }

  handleSaveData = async (data, onHandleNext) => {
    this.toggleLoadingRequesting(true)
    let messageError = 'Ocurrió un error al actualizar la información'

    try {
      let procedureUser = await this.procedureUserService.updateProcedureUser(this.freelanceId, data, this.token)
      if (procedureUser && procedureUser.data && Number(procedureUser.statusCode) === 200) {
        this.toggleLoadingRequesting(false)
        this.toggleCompletedRequesting(true, 3000)
        setTimeout(() => {
          onHandleNext()

        }, 3000)
      } else if (Number(procedureUser.statusCode) === -5) {
        messageError = 'No se encontro al usuario trámite en govo.legal'
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(true, 4000, messageError)
      } else if (Number(procedureUser.statusCode) === -6) {
        messageError = 'No se pudo actualizar el usuario trámite en govo.legal'
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(true, 4000, messageError)
      } else {
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(true, 400, messageError)
      }

    } catch (error) {
      this.toggleLoadingRequesting(false)
      this.toggleErrorRequesting(true, 400, messageError)
    }
  }

  handleUploadDocFree = async (e, documento, setShowAws, setLoadingDialog) => {
    setLoadingDialog(true)
    let messageError = 'Ocurrió un error al cargar el documento'
    let file = e.target.files[0]
    let userId = documento.userId
    let clientDocumentId = documento.clientDocumentId
    let userDocument = new FormData();
    userDocument.append("userDocument", file);
    userDocument.append("clientDocumentId", clientDocumentId);
    userDocument.append("userId", userId);
    userDocument.append("procedureUserId", this.freelanceId);

    try {
      let document = await this.procedureUserService.uploadDocumentProcedureUser(userDocument, this.token)
      if (document && document.data && Number(document.statusCode) === 200) {
        setShowAws(false)
        this.handleFile(e)
        this.getFreelanceData()
        setLoadingDialog(false)
      } else if (Number(document.statusCode) === -5) {
        messageError = 'No se encontro al usuario trámite en govo.legal'
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(true, 4000, messageError)
      } else if (Number(document.statusCode) === -6) {
        messageError = 'No se pudo actualizar el documento'
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(true, 4000, messageError)
      } else if (Number(document.statusCode) === -7) {
        messageError = 'No se pudo crear el documento'
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(true, 4000, messageError)
      } else {
        setLoadingDialog(false)
        this.toggleErrorRequesting(true, 4000, messageError)
      }
    } catch (error) {
      setLoadingDialog(false)
      this.toggleErrorRequesting(true, 4000, messageError)
    }
  }

  handleFinishFree = async () => {
    this.toggleLoadingRequesting(true)
    let messageError = 'Ocurrió un error al finalizar el proceso del alta del usuario'
    let documents = []

    try {
      let workflow = await this.procedureUserService.callProcedureUserWorkflow(this.freelanceId, this.workflowFreelanceId, 'next', null, this.token, documents)
      if (workflow && workflow.data && Number(workflow.statusCode) === 200) {
        this.toggleLoadingRequesting(false)
        this.toggleCompletedRequesting(true, 3000)
        setTimeout(() => {
          this.props.history.push("/")
        }, 3000)
      } else if (Number(workflow.statusCode) === -5) {
        messageError = 'No se encontro al usuario trámite en govo.legal'
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(true, 4000, messageError)
      } else if (Number(workflow.statusCode) === -6) {
        messageError = 'No se encontró el workflow relacionado al usuario'
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(true, 4000, messageError)
      } else if (Number(workflow.statusCode) === -7) {
        messageError = 'No se encontro el status relacionado al worflow del usuario'
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(true, 4000, messageError)
      } else if (Number(workflow.statusCode) === -8) {
        messageError = 'No ha terminado de cargar todos los documentos o información del usuario'
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(true, 4000, messageError)
      } else if (Number(workflow.statusCode) === -9) {
        messageError = 'No se pudo actualizar al siguiente status el workflow'
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(true, 4000, messageError)
      } else {
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(true, 400, messageError)
      }
    } catch (error) {
      this.toggleLoadingRequesting(false)
      this.toggleErrorRequesting(true, 400, messageError)
    }
  }

  uploadFormAnwsered = async (documento, setShowModalForms) => {
    let id = documento.id
    let answer = true
    let uploadForm = await this.procedureUserService.udpateformAnswered(id, answer, this.token)
    if (uploadForm && uploadForm.data && Number(uploadForm.statusCode) === 200) {
      setShowModalForms(false)
      this.getFreelanceData()
    }
  }

  render() {
    return (
      <div className="standard-wrapper">
        <ContractingRegistrationView
          {...this.state}
          steps={this.steps}
          stepMetadata={(this.isFreelanceView) ? this.stepMetadataFree : this.stepMetadata}
          validator={this.validator}
          setDocumentsSeleceted={this.setDocumentsSeleceted}
          toggleLoadingRequesting={this.toggleLoadingRequesting}
          toggleCompletedRequesting={this.toggleCompletedRequesting}
          toggleErrorRequesting={this.toggleErrorRequesting}
          setContractorClientDocuments={this.setContractorClientDocuments}
          handleDeleteFile={this.handleDeleteFile}
          handleFile={this.handleFile}
          setDocumentSeleceted={this.setDocumentSeleceted}
          handleSetNameDocument={this.handleSetNameDocument}

          handleSaveData={this.handleSaveData}
          getFreelanceData={this.getFreelanceData}
          handleFinishFree={this.handleFinishFree}
          handleUploadDocFree={this.handleUploadDocFree}
          uploadFormAnwsered={this.uploadFormAnwsered}
        />
      </div>
    );
  }
}

export default withTranslation()(ContractingRegistrationAction);
